export default "__VITE_ASSET__z77098qc__"